(function () {
  'use strict';

  // Configurable URL-param matchers. Add more sources as needed.
  //
  // COZY-107 (2026-05-29): TEMPORARILY DISABLED. The cookie-routed email-source
  // experience created an inconsistency between (a) the messaging an email
  // visitor saw and (b) the price they actually paid — EMAIL25 (25 %) shows
  // in the UI banner, but Shopify's discount engine kept applying the
  // larger public-Bxgy reward (e.g. 2-für-1) since custom-app Functions
  // require Shopify Plus and no app on Cozy's stack natively gates on
  // UTM / cart attribute. Until that gap is closed, no visitor gets routed
  // through the gate — empty matcher array means setCookie() never fires
  // on URL detection. EMAIL25 still works for anyone who types the code
  // at checkout or follows /discount/EMAIL25 (handled natively by Shopify).
  //
  // Re-enable: restore the original matcher when (1) Cozy goes Plus +
  // PR #1 on dark-factory-shopify deploys the suppression Function, or
  // (2) a discount engine is in place that natively gates the public Bxgy.
  var EMAIL_MATCHERS = [
    // function (params) { return (params.get('utm_source') || '').toLowerCase() === 'email'; }
  ];
  var COOKIE_NAME = 'cozy_email_visitor';
  var CLEAR_PARAM = 'cozy_email_visitor';
  var ATTR_HIDE = 'data-hide-on-email-source';
  var ATTR_SHOW_ONLY = 'data-show-only-on-email-source';

  // Max-Age in seconds. 3 days — campaign-window default (Fri → Mon).
  // Cookies older than this naturally expire on the client.
  var COOKIE_MAX_AGE = 60 * 60 * 24 * 3;

  // Cookie revision marker. The cookie value is set to this string. On read,
  // if the stored value doesn't equal CURRENT_REVISION the cookie is cleared
  // and the visitor is no longer treated as email-source. Bump this string
  // (e.g. '1' → '2') in a one-line PR to mass-invalidate every existing
  // cozy_email_visitor cookie across the customer base — handy when a
  // campaign ends or pricing logic changes and you need everyone back in
  // the public-sale path on next page-load.
  //
  // COZY-107 (2026-05-29): bumped 1 → 2 alongside the EMAIL_MATCHERS
  // shutdown above, so any visitor still carrying a revision-1 cookie
  // from before today's deploy gets reverted to the public-sale path on
  // their next page-load.
  var CURRENT_REVISION = '2';

  function setCookie() {
    document.cookie =
      COOKIE_NAME + '=' + CURRENT_REVISION +
      '; Path=/; Max-Age=' + COOKIE_MAX_AGE +
      '; SameSite=Lax';
  }

  function readCookie() {
    var m = document.cookie.match(new RegExp('(?:^|; )' + COOKIE_NAME + '=([^;]+)'));
    if (!m) return null;
    if (m[1] !== CURRENT_REVISION) {
      // Cookie was set under an older revision — invalidate it.
      clearCookie();
      return null;
    }
    return m[1];
  }

  function clearCookie() {
    document.cookie = COOKIE_NAME + '=; Path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
  }

  // 1. URL param handling
  var params = new URLSearchParams(window.location.search || '');
  if (params.get(CLEAR_PARAM) === '0') {
    clearCookie();
  } else if (EMAIL_MATCHERS.some(function (fn) { return fn(params); })) {
    setCookie();
  }

  // 2. Apply gating based on cookie state
  function applyGate() {
    if (readCookie() !== CURRENT_REVISION) return;
    var hideEls = document.querySelectorAll('[' + ATTR_HIDE + ']');
    for (var i = 0; i < hideEls.length; i++) {
      hideEls[i].setAttribute('hidden', '');
    }
    var showEls = document.querySelectorAll('[' + ATTR_SHOW_ONLY + ']');
    for (var j = 0; j < showEls.length; j++) {
      showEls[j].removeAttribute('hidden');
    }
  }

  // 3. Run as early as possible
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyGate, { once: true });
  } else {
    applyGate();
  }

  // 4. Re-apply on partial re-renders (PDP variant change, etc.)
  document.addEventListener('product:rerender', applyGate);
})();

// ===========================================================================
// Campaign offer gate (link/code -> offer flag)  [feature/link-offer-pillow]
// ---------------------------------------------------------------------------
// Moves offers from "automatic / everyone" to "link-only". A visitor arriving
// via a campaign link (e.g. ?offer=pillowgift) gets the offer persisted so the
// cart can surface the matching free-gift UI. This gates DISPLAY only — the
// money is still a native Shopify discount (PILLOWGIFT) applied by the same
// link, and later a Plus Discount Function reading the `_offer` cart attribute.
// A normal visit (no ?offer) sets nothing -> no flag -> no offer UI -> base price.
// ===========================================================================
(function () {
  'use strict';

  var OFFER_PARAM = 'offer';
  var OFFER_COOKIE = 'cozy_offer';
  // 3 days — matches the campaign-window default used above.
  var OFFER_MAX_AGE = 60 * 60 * 24 * 3;

  function clearOffer() {
    document.cookie = OFFER_COOKIE + '=; Path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
  }

  function setOfferCookie(offer) {
    document.cookie =
      OFFER_COOKIE + '=' + encodeURIComponent(offer) +
      '; Path=/; Max-Age=' + OFFER_MAX_AGE + '; SameSite=Lax';
  }

  // Read the active offer for other scripts (the cart gift module).
  window.cozyActiveOffer = function () {
    var m = document.cookie.match(/(?:^|; )cozy_offer=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  };

  var params = new URLSearchParams(window.location.search || '');
  var offer = (params.get(OFFER_PARAM) || '').trim().toLowerCase();

  // ?offer=none (or 0) clears the campaign — cookie AND cart attribute — so the
  // offer is fully off (lets us reset a test cart, and gives a real off-switch).
  if (offer === 'none' || offer === '0') {
    clearOffer();
    var clearRoutes = (window.themeVariables && window.themeVariables.routes) || {};
    fetch(clearRoutes.cartUpdateUrl || '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { _offer: '' } })
    }).catch(function () { /* non-fatal */ });
    return;
  }

  if (!offer) return; // normal visit — leave any existing flag untouched.

  setOfferCookie(offer);

  // Mirror into a cart attribute so the cart UI + (future) Discount Function
  // can read the campaign server-side. Fire-and-forget; never blocks the page.
  var routes = (window.themeVariables && window.themeVariables.routes) || {};
  fetch(routes.cartUpdateUrl || '/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ attributes: { _offer: offer } })
  }).catch(function () { /* non-fatal */ });
})();

// ---------------------------------------------------------------------------
// Offer self-heal  [feature/bettdecken-duo]
//
// Why this exists. The cozy_offer COOKIE is the durable campaign signal (3 days).
// The `_offer` CART ATTRIBUTE is what the Plus Discount Functions actually read.
// The block above writes the attribute once, on the page carrying ?offer= — which
// is normally the landing page, when the cart is still empty. Nothing re-asserts it
// afterwards.
//
// The gift offers got away with that because cozy-cart-gift-offer.js re-writes
// `_offer` immediately before adding a gift (its own "self-heal" comment). A
// percentage offer such as the Bettdecken-Duo adds no gift, so it never reaches
// that moment: if the first write didn't stick, the visitor silently pays full
// price and nothing anywhere reports a problem.
//
// So: on every page load, if the cookie says a campaign is active and the cart has
// items, make the attribute agree. Deliberately conservative —
//   * does nothing without the cookie (no cost for ordinary visitors)
//   * never writes to an EMPTY cart, sidestepping the question of whether Shopify
//     persists attributes on one
//   * only writes when cookie and cart actually disagree, so it is a no-op read on
//     nearly every page view
// ---------------------------------------------------------------------------
(function cozyOfferSelfHeal() {
  var cookieOffer =
    typeof window.cozyActiveOffer === 'function' ? window.cozyActiveOffer() : null;
  if (!cookieOffer) return;

  var routes = (window.themeVariables && window.themeVariables.routes) || {};

  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (!cart || !cart.item_count) return; // empty cart: nothing to attach to
      var current = (cart.attributes || {})._offer;
      if (current === cookieOffer) return; // already correct
      return fetch(routes.cartUpdateUrl || '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { _offer: cookieOffer } })
      });
    })
    .catch(function () { /* non-fatal — never block the page for an offer flag */ });
})();

// ---------------------------------------------------------------------------
// Campaign price display  [feature/schlafmaske-campaign-price]
//
// Swaps the PDP price for visitors carrying a campaign cookie: the normal price
// list is hidden and the campaign one (rendered hidden by new-product-form.liquid,
// with the strikethrough and the -N% badge) is revealed.
//
// DISPLAY ONLY. The money comes from the matching Discount Function, which gates on
// the SAME campaign value via the cart's `_offer` attribute and reads the SAME shop
// metafield for its numbers. Both sides derive from one config, so the shown price
// and the charged price cannot drift apart.
//
// WHY THAT MATTERS HERE. This is precisely the failure that got the email-source gate
// switched off in COZY-107 (see the top of this file): visitors were shown one price
// and charged another. The guards against a repeat are (a) one shared config, (b) the
// offer self-heal above, which keeps the cart attribute in step with the cookie, and
// (c) failing closed — no cookie, no match, or no campaign markup and nothing changes,
// leaving the shelf price exactly as rendered.
//
// Generic on purpose: any future link offer gets this for free by rendering
// data-cozy-offer-price / data-cozy-offer-default with its own ?offer= value.
// ---------------------------------------------------------------------------
(function cozyOfferPriceDisplay() {
  function apply() {
    var offer =
      typeof window.cozyActiveOffer === 'function' ? window.cozyActiveOffer() : null;
    if (!offer) return; // ordinary visitor — leave the shelf price alone

    var campaign = document.querySelectorAll('[data-cozy-offer-price]');
    if (!campaign.length) return; // no campaign markup on this page

    // Compare in JS rather than interpolating the cookie into a selector.
    var revealed = false;
    for (var i = 0; i < campaign.length; i++) {
      if (campaign[i].getAttribute('data-cozy-offer-price') !== offer) continue;
      // Write only on an actual change, so the observer below cannot re-trigger
      // itself into a loop.
      if (campaign[i].hidden) campaign[i].hidden = false;
      revealed = true;
    }

    // Only ever hide the normal price once its replacement is actually on screen.
    // Reversed, a mismatch would leave the product with no visible price at all.
    if (!revealed) return;

    var normal = document.querySelectorAll('[data-cozy-offer-default]');
    for (var j = 0; j < normal.length; j++) {
      if (normal[j].getAttribute('data-cozy-offer-default') !== offer) continue;
      if (!normal[j].hidden) normal[j].hidden = true;
    }

    applyButtonPrice(offer);
  }

  // ---------------------------------------------------------------------------
  // The add-to-cart button carries its own copy of the price ("Zum Warenkorb
  // hinzufuegen - EUR 49,90", COZY-27). Swapping only the price block left the button
  // advertising the shelf price next to a discounted one.
  //
  // AddToCartTotal (assets/custom.js) OWNS that label: it recomputes textContent from
  // data-unit-price on every quantity change, and resets data-unit-price from the
  // variant on variant:changed. So rewriting the text alone would be undone by the
  // next interaction, and would break quantity maths (2 x shelf instead of 2 x
  // campaign). We therefore move the ATTRIBUTE and let that component reformat, which
  // also avoids duplicating its money formatter.
  // ---------------------------------------------------------------------------
  function applyButtonPrice(offer) {
    var els = document.querySelectorAll('[data-cozy-offer-unit-price]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.getAttribute('data-cozy-offer-name') !== offer) continue;

      var campaign = el.getAttribute('data-cozy-offer-unit-price');
      if (!campaign) continue;

      // Only when it actually differs. Without this guard the dispatch below would
      // re-enter through the MutationObserver and loop forever.
      if (el.dataset.unitPrice === campaign) continue;
      el.dataset.unitPrice = campaign;

      // Hand back to AddToCartTotal, which listens for change on the form and will
      // reformat using the shop's own money format and the current quantity.
      el.dispatchEvent(new Event('change', {bubbles: true}));
    }
  }

  // Coalesce bursts of DOM mutations into one apply() per frame.
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    var run = function () {
      queued = false;
      apply();
    };
    if (window.requestAnimationFrame) window.requestAnimationFrame(run);
    else setTimeout(run, 16);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }

  // The price block re-renders on variant change. Both events bubble to document
  // (verified in theme.js), so one listener each is enough to re-apply the swap.
  document.addEventListener('variant:change', schedule);
  document.addEventListener('variant:changed', schedule);

  // ---------------------------------------------------------------------------
  // Re-apply after a colour switch.
  //
  // The colour swatches are NOT links. <product-connector> (assets/custom.js)
  // fetches the other product's section and replaces the section's innerHTML, then
  // calls history.replaceState. No navigation, no page load, and crucially NO event
  // of any kind. So the freshly injected markup arrives with the campaign price
  // hidden and nothing ever un-hides it: switch to the other colour and back, and a
  // campaign visitor silently drops to the shelf price.
  //
  // A MutationObserver is used rather than patching ProductConnector because the
  // price block is re-rendered by several paths (colour switch, variant change,
  // app blocks) and only some of them announce it. This catches all of them.
  //
  // Cost is negligible: the callback only sets a flag, apply() runs at most once
  // per frame, and it writes only when a value actually changes.
  // ---------------------------------------------------------------------------
  function observe() {
    // This script is parser-blocking in <head> (see layout/theme.liquid), so
    // document.body does not exist yet at first execution - attaching the observer
    // here directly would silently no-op and the colour-switch bug would survive.
    if (!window.MutationObserver || !document.body) return;
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
